export const SORT = [
  {
    header: "Sort By",
    className: "header",
  },
  {
    list: "Default",
    className2: "active unactive",
  },
  {
    list: "Popularity",
    className2: "active unactive",
  },
  {
    list: "Average rating",
    className2: "active unactive",
  },
  {
    list: "Newness",
    className2: "active",
  },
  {
    list: "Price: Low to High",
    className2: "active unactive",
  },
  {
    list: "Price: High to Low",
    className2: "active unactive",
  },
];

export const PRICE = [
  {
    header2: "Price",
    className: "header",
  },
  {
    list2: "All",
    className2: "active",
  },
  {
    list2: "$0.00 - $50.00",
    className2: "active unactive",
  },
  {
    list2: "$50.00 - $100.00",
    className2: "active unactive",
  },
  {
    list2: "$100.00 - $150.00",
    className2: "active unactive",
  },
  {
    list2: "$150.00 - $200.00",
    className2: "active unactive",
  },
  {
    list2: "$200.00+",
    className2: "active unactive",
  },
];

export const SORRTII = [
  {
    header3: "Sort By",
    className: "header",
  },
  {
    list3: "Category",
    className2: "active unactive",
  },
  {
    list3: "Action",
    className2: "active unactive",
  },
  {
    list3: "Adventure",
    className2: "active",
  },
  {
    list3: "Role Play",
    className2: "active unactive",
  },
  {
    list3: "Open World",
    className2: "active unactive",
  },
  {
    list3: "Sports",
    className2: "active unactive",
  },
];

export const TAGS = [
  {
    list4: "Action",
    classNameAcitve: "actives",
  },
  {
    list4: "Adventure",
    classNameAcitve: "actives",
  },
  {
    list4: "Multi-Player",
    classNameAcitve: "actives",
  },
  {
    list4: "Shooting Game",
    classNameAcitve: "actives",
  },
  {
    list4: "Open World",
    classNameAcitve: "actives",
  },
  {
    list4: "Role Play",
    classNameAcitve: "actives",
  },
  {
    list4: "Top Rated",
    classNameAcitve: "actives",
  },
];
